var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainBoxed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24919 0.633646C2.42821 0.633646 0.952006 2.10985 0.952006 3.93083V21.564C0.952006 23.385 2.4282 24.8612 4.24919 24.8612H22.0693C23.8903 24.8612 25.3665 23.385 25.3665 21.564V3.93083C25.3665 2.10985 23.8903 0.633646 22.0693 0.633646H4.24919Z",
    fill: "#FAFAFA",
    stroke: "#D0D8DC",
    strokeWidth: 0.732708
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7503 11C18.8233 11 18.0403 11.558 17.6892 12.35H15.0612C14.7102 11.558 13.9272 11 13.0002 11C12.0731 11 11.2901 11.558 10.9391 12.35H8.31108C7.96007 11.558 7.17706 11 6.25004 11C5.00802 11 4 12.008 4 13.25C4 14.4921 5.00802 15.5001 6.25004 15.5001C7.17706 15.5001 7.96007 14.9421 8.31108 14.1501H10.9391C11.2901 14.9421 12.0731 15.5001 13.0002 15.5001C13.9272 15.5001 14.7102 14.9421 15.0612 14.1501H17.6892C18.0403 14.9421 18.8233 15.5001 19.7503 15.5001C20.9923 15.5001 22.0003 14.4921 22.0003 13.25C22.0003 12.008 20.9923 11 19.7503 11Z",
    fill: "#7E898F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainBoxed);
export default __webpack_public_path__ + "static/media/ChainBoxed.4a76dee1402e9edaeb184551def64d4e.svg";
export { ForwardRef as ReactComponent };